import { Helper } from "../../core/util/helper.js";
import { CommonApp, CommonAppProps, Context } from "../../core/components/commonApp.js";
import { AppHelper } from "../../appHelper.js";
import { SheetEventType } from "../../../siteManagement/sheet.js";
import { MetaDataHelper } from "../../core/util/metaDataHelper.js";
import { PartRequirementsEntity } from "./workPackage.js";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager.js";
import { DialogHelper } from "../../core/util/dialogHelper.js";
import { MaterialPriceDiscount } from "../../editArticle/editArticle.js";
import { StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";

export class EditWorkPackagePartApp extends React.Component<EditWorkPackagePartProps, any> {
    common = new AppHelper();
    translations: StringKeyDictionary<string>;
    taskMachinesDs: []
    // wird von CommonApp interpretiert und aus FormConfig referenziert.
    parentContextType: string;
    customPricesVisible: boolean = null;

    constructor(props: EditWorkPackagePartProps) {
        super(props);
        this.parentContextType = props.context.parentContextType;
        this.taskMachinesDs = props.context.dataSources.taskMachines;
        this.common.enableHooks = true;
        this.common.init(this);
    }

    private _updateFromPriceList = async (anzahl: number = null, datum: Date = null, force: boolean = false) => {
        anzahl = anzahl ?? this.props.entity.Anzahl;
        datum = datum ?? this.props.entity.Datum;
        if (this.customPricesVisible) {
            let result: JsonResultClass<MaterialPriceDiscount> = null;
            if (this.props.context.contextType == "editWorkPackageParts")
                result = await HTTPService.get<JsonResultClass<MaterialPriceDiscount>>("WorkPackage/GetPrice",
                    {
                        artikelNr: this.props.entity.Artikelnr,
                        anzahl: anzahl,
                        workPackageId: this.props.context.parentId,
                        datum: datum
                    });
            if (result && result.Code == 0) {
                this.props.entity.MaterialPriceDiscount.Price = result.Data.Price;
                this.props.entity.MaterialPriceDiscount.PurchasePrice = result.Data.PurchasePrice;
                this.props.entity.MaterialPriceDiscount.Discount = result.Data.Discount;
                if (force || !this.props.entity.CustomPrices) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Epreis", this.props.entity.MaterialPriceDiscount.Price);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.EkPreis", this.props.entity.MaterialPriceDiscount.PurchasePrice);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Rabatt", this.props.entity.MaterialPriceDiscount.Discount);
                    this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis,
                        this.props.entity.Epreis, this.props.entity.Rabatt);
                    this.setState({});
                }
            }
        }
    }

    handleFieldChange = async (field: { model: string }, value: any, dataItem = null, isInit = false) => {
        MetaDataHelper.setFieldValue(this.props.entity, "entity.Changed", true);
        switch (field.model) {
            case "entity.Maschnr":
                if (Helper.hasValue(dataItem)) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Maschnr", dataItem.Key);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.MaschBezeichnung", dataItem.Value);
                    await this.loadIndividualFieldsMaind(value);
                }
                break;
            case "entity.LinkedTypeValue":
                if (Helper.hasValue(dataItem)) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.LinkedType", { Name: dataItem.Name, Title: dataItem.Title, Value: dataItem.Value });
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.LinkedTypeValue", dataItem.Value);
                }
                break;
            case "entity.Anzahl":
                await this._updateFromPriceList(value as number);
                this._updateValues(value, this.props.entity.EkPreis, this.props.entity.Epreis, this.props.entity.Rabatt);
                break;
            case "entity.EkPreis":
                this._updateValues(this.props.entity.Anzahl, value, this.props.entity.Epreis, this.props.entity.Rabatt);
                break;
            case "entity.Epreis":
                this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, value, this.props.entity.Rabatt);
                break;
            case "entity.Rabatt":
                this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, this.props.entity.Epreis, value);
                break;
            case "entity.Datum":
                await this._updateFromPriceList(null, value as Date);
                this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, this.props.entity.Epreis, this.props.entity.Rabatt);
                break;
            case "entity.CustomPrices":
                this.updateReadOnly(!value);
                if (!value) {
                    await this._updateFromPriceList(null, null, true);
                }
                break;
            default:
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    apply = () => {
        if (this.common.validate()) {
            this.common.setEntityDirtyState(false);
            this.common.sheetWrapper.trigger(SheetEventType.SavedSuccessfully, this.props.entity);
            this.common.sheetWrapper.hide();
        }
    }
    handleIsSearchFieldFullObjectModel = async (field: { model: string }, dataItem: any) => {
        let changed = true;
        switch (field.model) {
            case "entity.Artikelnummer":
                if (Helper.hasValue(dataItem)) {
                    let part = dataItem as ArticleSearchItem;
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Artikelnr", part.artnr);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Artikelnummer", part.artikelnummer);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Produkt", part.produkt);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Bezeichnung", part.bezeichnung);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Epreis", part.preis);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.EkPreis", part.ekpreis);

                    MetaDataHelper.setFieldValue(this.props.entity, "entity.CustomPrices", false);
                    this.updateReadOnly(true);
                    // KT - _updateFromPriceList aktualisiert die Summen auch, aber nur bei erfolgreicher Ermittlung
                    //   für die Templates wird aber keine Ermittlung gemacht. Die Summen sollte man aber trotzdem aktualisieren.
                    this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, this.props.entity.Epreis, this.props.entity.Rabatt);
                    await this._updateFromPriceList(null, null, true);
                    this.setState({});
                }
                break;
            case "entity.Maschnr":
                if (Helper.hasValue(dataItem)) {
                    let machine = dataItem as MachineSearchItem;
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Maschnr", machine.maschnr);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.MaschBezeichnung", machine.maschbezeichnung);
                }
                break;
            default:
                changed = false;
                break;
        }
        if (changed) {
            this.common.handleFieldChange({ model: "" }, null, null);
        }
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextEpreis = () => {
        return this.customPricesVisible && this.props.entity.CustomPrices ?
            Helper.getTranslation("Field.Material.FromPL") + " " + this.props.entity.MaterialPriceDiscount.Price.toFixed(2) : null;
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextColorEpreis = () => {
        return this.customPricesVisible && this.props.entity.CustomPrices ?
            this.props.entity.MaterialPriceDiscount.Price === this.props.entity.Epreis ? "#448aff" : "#d50000" : null
    }


    // noinspection JSUnusedGlobalSymbols
    getInfoTextEkpreis = () => {
        return this.customPricesVisible && this.props.entity.CustomPrices ?
            Helper.getTranslation("Field.Material.FromPL") + " " + this.props.entity.MaterialPriceDiscount.PurchasePrice.toFixed(2) : null;
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextColorEkpreis = () => {
        return this.customPricesVisible && this.props.entity.CustomPrices ?
            this.props.entity.MaterialPriceDiscount.PurchasePrice === this.props.entity.EkPreis ? "#448aff" : "#d50000" : null
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextRabatt = () => {
        return this.customPricesVisible && this.props.entity.CustomPrices ?
            Helper.getTranslation("Field.Material.FromPL") + " " + this.props.entity.MaterialPriceDiscount.Discount + " %" : null
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextColorRabatt = () => {
        if (!this.props.entity.CustomPrices)
            return null;
        return this.props.entity.MaterialPriceDiscount.Discount === this.props.entity.Rabatt ? "#448aff" : "#d50000";
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextGpreis = () => {
        if (this.props.entity.Rabatt != null && this.props.entity.Rabatt != 0) {
            return (this.props.entity.Anzahl * this.props.entity.Epreis).toFixed(2) + " - " + this.props.entity.Rabatt.toString() + " %";
        }
    }

    // noinspection JSUnusedGlobalSymbols
    getInfoTextColorGpreis = () => {
        return "#448aff";
    }

    // noinspection JSUnusedGlobalSymbols
    executeKosten = () => {
        const text = Helper.getTranslation("Field.Material.EnterTotalCost");
        const kosten = this.props.entity.Kosten;
        DialogHelper.promptNumber(text, kosten, "0.00", 2, true, 0, 500).then((result) => {
            if (!Helper.isNullOrEmpty(result)) {
                const sum = parseFloat(result);
                if (kosten != sum) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.CustomPrices", true);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.EkPreis", sum / this.props.entity.Anzahl);
                    this.updateReadOnly(false);
                    this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, this.props.entity.Epreis, this.props.entity.Rabatt);
                    this.setState({});
                }
            }
        })
    }

    // noinspection JSUnusedGlobalSymbols
    executeGpreis = () => {
        const text = Helper.getTranslation("Field.Material.EnterTotalPrice");
        const gpreis = this.props.entity.Gpreis;
        DialogHelper.promptNumber(text, gpreis, "0.00", 2, true, 0, 500).then((result) => {
            if (!Helper.isNullOrEmpty(result)) {
                const sum = parseFloat(result);
                if (sum != gpreis) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.CustomPrices", true);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Rabatt", 0);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Epreis", sum / this.props.entity.Anzahl);
                    this.updateReadOnly(false);
                    this._updateValues(this.props.entity.Anzahl, this.props.entity.EkPreis, this.props.entity.Epreis, this.props.entity.Rabatt);
                    this.setState({});
                }
            }
        })
    }

    private loadIndividualFieldsMaind = async (maschNr: string) => {
        let result = await HTTPService.get<JsonResultClass>("Machine/GetMaind?maschNr=" + encodeURIComponent(maschNr));
        if (result.Code == 0) {
            MetaDataHelper.setFieldValue(this.props.entity, "entity.IndividualFieldsMaind", result.Data);
            this.setState({});
        }
    }

    componentDidMount() {
        if (this.customPricesVisible == null) {
            const field = MetaDataHelper.getFieldByModelName(this.props.metadata, "entity.CustomPrices");
            let visible = false;
            if (field != null) {
                if (typeof (field.visibleCondition) == "string") visible = this.common.evalAction(field.visibleCondition);
                else visible = field.visibleCondition as boolean;
            }
            this.customPricesVisible = visible;
        }

        let readOnly = this.customPricesVisible && !this.props.entity.CustomPrices;

        this.updateReadOnly(readOnly);
    }

    private _updateValues(quantity: number, purchasePrice: number, unitPrice: number, discount: number) {
        let sum = parseFloat((quantity * unitPrice).toFixed(2));
        let discountValue = parseFloat(((sum / 100) * discount).toFixed(2));
        sum -= discountValue;
        MetaDataHelper.setFieldValue(this.props.entity, "entity.Gpreis", sum);

        sum = parseFloat((quantity * purchasePrice).toFixed(2));
        MetaDataHelper.setFieldValue(this.props.entity, "entity.Kosten", sum);
    }

    private updateReadOnly(value: boolean) {
        if (this.customPricesVisible) {
            MetaDataHelper.setReadOnly(this.props.metadata, "entity.Epreis", value);
            MetaDataHelper.setReadOnly(this.props.metadata, "entity.EkPreis", value);
            MetaDataHelper.setReadOnly(this.props.metadata, "entity.Rabatt", value);
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        return <CommonApp {...props} />;
    }
}

interface ArticleSearchItem {
    artnr: number;
    artikelnummer: string;
    preis: number;
    ekpreis: number;
    produkt: string;
    bezeichnung: string;
}

interface MachineSearchItem {
    maschnr: string;
    maschbezeichnung: string;
}

export interface EditWorkPackagePartProps extends CommonAppProps {
    disabled: boolean;
    context: EditWorkPackagePartsContext;
    entity: PartRequirementsEntity;
}

interface EditWorkPackagePartsContext extends Context {
    dataSources: any;
    parentContextType: string;
    parentId: string;
}
